export default __webpack_public_path__ + "static/media/real-life-CRASH1.b365755a.mp3";